<template>
	<div class="delivery_banner">

		<div class="delivery_banner__content">

			<div class="delivery_banner__postcode_content">

				<div class="delivery_banner__postcode_content--inner" :class="{'delivery_banner__postcode_content--active': step.postcode}">

					<p class="delivery_banner__h1">We offer flexible nationwide delivery</p>

					<p class="delivery_banner__h2">And extra services just for our local customers.</p>

					<p class="delivery_banner__p1">Please refer to the map opposite to see if you are in our ‘local’ delivery areas.</p>

				</div>

				<div class="delivery_banner__postcode_content--inner" :class="{'delivery_banner__postcode_content--active': step.local}">

					<p class="delivery_banner__h2">You qualify for free local delivery*</p>

					<p class="delivery_banner__h3"><span class="delivery_banner--orange">Remember</span> to add your post code at checkout.</p>

					<p class="delivery_banner__p1">*Spend over £29</p>

					<p class="delivery_banner__back" @click="resetSteps()">Go back</p>

				</div>

				<div class="delivery_banner__postcode_content--inner" :class="{'delivery_banner__postcode_content--active': step.nationwide}">

					<p class="delivery_banner__h2">You can use our nationwide service for named day or next day delivery. </p>

					<p class="delivery_banner__p2">You are outside our ‘local’ delivery area.</p>

					<p class="delivery_banner__back" @click="resetSteps()">Go back</p>

				</div>

			</div>

			<div class="delivery_banner__graphic" :class="{'delivery_banner__graphic--active': modal.active}">

				<figure class="delivery_banner__svgwrap">
					<div class="delivery_banner__local">
						<p>Local delivery area</p>
						<span @click="openModal()">Check your postcode</span>
					</div>
					<div class="delivery_banner__nationwide">
						<p>Nationwide delivery area</p>
					</div>
					<img class="delivery_banner__svg" :src="themeurl + '/images/svg/del-map.svg'" alt="">
				</figure>

				<div class="delivery_banner__postcode_modal">

					<span class="delivery_banner__postcode_modal--close" @click="closeModal()"></span>
					<p>Simply enter your postcode to see if you are in our local delivery area</p>
					<input-postcode v-model="postcode" v-bind:postcode_result.sync="postcode_result"></input-postcode>

				</div>

			</div>

		</div>
	</div>
</template>

<script>

	import InputPostcode from './input-postcode.vue';

	export default {
		components: {
			'input-postcode': InputPostcode
		},
		data: function() {
			return {
				modal: {
					active: false
				},
				postcode: '',
				postcode_result: {},
				step: {
					postcode: true,
					local: false,
					nationwide: false
				},
				themeurl: WPURLS['template_directory']
			}
		},
		watch: {
			postcode_result: function() {
				this.step.postcode = false;

				this.step.local = false;
				this.step.nationwide = false;

				if (this.postcode_result['Local'] == true) {
					this.step.local = true;
				} else {
					this.step.nationwide = true;
				}
			}
		},
		computed: {

		},
		created() {
			jQuery('.fp_check_postcode').click((e) => {
				e.preventDefault();
				this.openModal();
			});
		},
		methods: {
			openModal() {
				this.modal.active = true;
			},
			closeModal() {
				this.modal.active = false;
			},
			resetSteps() {
				this.postcode = '';
				this.step.postcode = true;
				this.step.local = false;
				this.step.nationwide = false;
			}
		}
	}
</script>
